var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1086 906",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes chart-ani-01{0%{transform:translateY(0)}to{transform:translateY(130px)}}@keyframes chart-ani-02{0%{transform:translateY(50px)}to{transform:translateY(180px)}}@keyframes chart-ani-03{0%{transform:translateY(100px)}to{transform:translateY(0)}}@keyframes volume-ani{0%{opacity:0}25%{opacity:1}}.chart_svg__chart-01{animation-name:chart-ani-01;animation-duration:2s}.chart_svg__chart-01,.chart_svg__chart-02,.chart_svg__chart-03{animation-iteration-count:infinite;animation-direction:alternate;animation-timing-function:cubic-bezier(.65,.45,.65,.5)}.chart_svg__chart-02{animation-name:chart-ani-02;animation-duration:1.8s;animation-delay:.3s}.chart_svg__chart-03{animation-name:chart-ani-03;animation-duration:1.6s}.chart_svg__volume path{opacity:0;animation:volume-ani 2s infinite}.chart_svg__mask-polygon{fill:var(--bs-white)}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "chart_svg__shadows"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-120 30.297 726.171)",
    fill: "url(#chart_svg__paint0_linear_547_5742)",
    d: "M30.297 726.171h40v200h-40z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-120 326.297 904.654)",
    fill: "url(#chart_svg__paint1_linear_547_5742)",
    d: "M326.297 904.654h40v200h-40z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-120 410.297 632.654)",
    fill: "url(#chart_svg__paint2_linear_547_5742)",
    d: "M410.297 632.654h40v200h-40z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-120 198.297 836.654)",
    fill: "url(#chart_svg__paint3_linear_547_5742)",
    d: "M198.297 836.654h40v476h-40z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-120 286.297 568.654)",
    fill: "url(#chart_svg__paint4_linear_547_5742)",
    d: "M286.297 568.654h40v476h-40z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-120 673.297 783.654)",
    fill: "url(#chart_svg__paint5_linear_547_5742)",
    d: "M673.297 783.654h40v476h-40z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#chart_svg__mask-01)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "chart_svg__chart-01",
    d: "M257.297 17.013l29.569-17 28.431 17-29 17-29-17z",
    fill: "#C0C6FF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "chart_svg__chart-01",
    d: "M257.297 552.11V17.013l29 17v535l-29-16.903z",
    fill: "url(#chart_svg__paint6_linear_547_5742)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "chart_svg__chart-01",
    d: "M286.297 34.013l29-17v535l-29 17v-535z",
    fill: "url(#chart_svg__paint7_linear_547_5742)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#chart_svg__mask-02)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "chart_svg__chart-01",
    d: "M169.297 285.013l29.569-17 28.431 17-29 17-29-17z",
    fill: "#FDE50F"
  }), /*#__PURE__*/React.createElement("path", {
    className: "chart_svg__chart-01",
    d: "M169.297 820.11V285.013l29 17v535l-29-16.903z",
    fill: "url(#chart_svg__paint8_linear_547_5742)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "chart_svg__chart-01",
    d: "M198.297 302.013l29-17v535l-29 17v-535z",
    fill: "url(#chart_svg__paint9_linear_547_5742)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#chart_svg__mask-03)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "chart_svg__chart-03",
    d: "M.297 439.013l30-17 29 17-29 17-30-17z",
    fill: "#C0C6FF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "chart_svg__chart-03",
    d: "M.297 709.013v-270l30 17v270l-30-17z",
    fill: "url(#chart_svg__paint10_linear_547_5742)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "chart_svg__chart-03",
    d: "M30.297 456.013l29-17v270.022l-29 16.978v-270z",
    fill: "url(#chart_svg__paint11_linear_547_5742)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#chart_svg__mask-04)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "chart_svg__chart-03",
    d: "M644.297 232.013l29.569-17 28.431 17-29 17-29-17z",
    fill: "#9DB8FF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "chart_svg__chart-03",
    d: "M644.297 767.11V232.013l29 17v535l-29-16.903z",
    fill: "url(#chart_svg__paint12_linear_547_5742)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "chart_svg__chart-03",
    d: "M673.297 249.013l29-17v535l-29 17v-535z",
    fill: "url(#chart_svg__paint13_linear_547_5742)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#chart_svg__mask-05)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "chart_svg__chart-02",
    d: "M380.297 346.013l30-17 29 17-29 17-30-17z",
    fill: "#FDE50F"
  }), /*#__PURE__*/React.createElement("path", {
    className: "chart_svg__chart-02",
    d: "M380.297 616.013v-270l30 17v270l-30-17z",
    fill: "url(#chart_svg__paint14_linear_547_5742)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "chart_svg__chart-02",
    d: "M410.297 363.013l29-17v270.022l-29 16.978v-270z",
    fill: "url(#chart_svg__paint15_linear_547_5742)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#chart_svg__mask-06)"
  }, "&gt;", /*#__PURE__*/React.createElement("path", {
    className: "chart_svg__chart-02",
    d: "M296.297 618.013l30-17 29 17-29 17-30-17z",
    fill: "#9DB8FF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "chart_svg__chart-02",
    d: "M296.297 888.013v-270l30 17v270l-30-17z",
    fill: "url(#chart_svg__paint16_linear_547_5742)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "chart_svg__chart-02",
    d: "M326.297 635.013l29-17v270.022l-29 16.978v-270z",
    fill: "url(#chart_svg__paint17_linear_547_5742)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "chart_svg__volume"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      animationDelay: ".7s"
    },
    d: "M464.297 554.013l11 6v12l-11-6v-12z",
    fill: "#326BFF"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      animationDelay: ".6s"
    },
    d: "M464.297 570.013l11 6v12l-11-6.116v-11.884z",
    fill: "#9DEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      animationDelay: ".5s"
    },
    d: "M464.297 586.013l11 6v12l-11-6.116v-11.884z",
    fill: "#9DEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      animationDelay: ".4s"
    },
    d: "M464.297 602.013l11 6v12l-11-6.116v-11.884z",
    fill: "#9DEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      animationDelay: ".3s"
    },
    d: "M464.297 618.013l11 6v12l-11-6.116v-11.884z",
    fill: "#9DEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      animationDelay: ".2s"
    },
    d: "M464.297 634.013l11 6v12l-11-6.116v-11.884z",
    fill: "#9DEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      animationDelay: ".1s"
    },
    d: "M464.297 650.013l11 6v12l-11-6.116v-11.884z",
    fill: "#9DEDFF"
  })), /*#__PURE__*/React.createElement("g", {
    className: "chart_svg__volume",
    fill: "#9DEDFF"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      animationDelay: ".6s"
    },
    d: "M485.297 599.013l11 6v12l-11-6.116v-11.884z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      animationDelay: ".5s"
    },
    d: "M485.297 615.013l11 6v12l-11-6.116v-11.884z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      animationDelay: ".4s"
    },
    d: "M485.297 631.013l11 6v12l-11-6.116v-11.884z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      animationDelay: ".3s"
    },
    d: "M485.297 647.013l11 6v12l-11-6.116v-11.884z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      animationDelay: ".2s"
    },
    d: "M485.297 663.013l11 6v12l-11-6.116v-11.884z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "chart_svg__volume"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      animationDelay: "1s"
    },
    d: "M506.297 563.013l11 6v12l-11-6v-12z",
    fill: "#326BFF"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      animationDelay: ".9s"
    },
    d: "M506.297 579.013l11 6v12l-11-6v-12z",
    fill: "#9DEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      animationDelay: ".8s"
    },
    d: "M506.297 595.013l11 6v12l-11-6.116v-11.884z",
    fill: "#9DEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      animationDelay: ".7s"
    },
    d: "M506.297 611.013l11 6v12l-11-6.116v-11.884z",
    fill: "#9DEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      animationDelay: ".6s"
    },
    d: "M506.297 627.013l11 6v12l-11-6.116v-11.884z",
    fill: "#9DEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      animationDelay: ".5s"
    },
    d: "M506.297 643.013l11 6v12l-11-6.116v-11.884z",
    fill: "#9DEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      animationDelay: ".4s"
    },
    d: "M506.297 659.013l11 6v12l-11-6.116v-11.884z",
    fill: "#9DEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      animationDelay: ".3s"
    },
    d: "M506.297 675.013l11 6v12l-11-6.116v-11.884z",
    fill: "#9DEDFF"
  })), /*#__PURE__*/React.createElement("g", {
    className: "chart_svg__volume",
    fill: "#9DEDFF"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      animationDelay: ".7s"
    },
    d: "M527.297 623.013l11 6v12l-11-6.116v-11.884z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      animationDelay: ".6s"
    },
    d: "M527.297 639.013l11 6v12l-11-6.116v-11.884z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      animationDelay: ".5s"
    },
    d: "M527.297 655.013l11 6v12l-11-6.116v-11.884z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      animationDelay: ".4s"
    },
    d: "M527.297 671.013l11 6v12l-11-6.116v-11.884z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      animationDelay: ".3s"
    },
    d: "M527.297 687.013l11 6v12l-11-6.116v-11.884z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "chart_svg__volume",
    fill: "#9DEDFF"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      animationDelay: ".4s"
    },
    d: "M569.297 663.013l11 6v12l-11-6.116v-11.884z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      animationDelay: ".3s"
    },
    d: "M569.297 679.013l11 6v12l-11-6.116v-11.884z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      animationDelay: ".2s"
    },
    d: "M569.297 695.013l11 6v12l-11-6.116v-11.884z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      animationDelay: ".1s"
    },
    d: "M569.297 711.013l11 6v12l-11-6.116v-11.884z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "chart_svg__paint0_linear_547_5742",
    x1: 50.297,
    y1: 726.171,
    x2: 50.297,
    y2: 926.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDBDBD",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBDBD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chart_svg__paint1_linear_547_5742",
    x1: 346.297,
    y1: 904.654,
    x2: 346.297,
    y2: 1104.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDBDBD",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBDBD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chart_svg__paint2_linear_547_5742",
    x1: 430.297,
    y1: 632.654,
    x2: 430.297,
    y2: 832.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDBDBD",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBDBD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chart_svg__paint3_linear_547_5742",
    x1: 218.297,
    y1: 836.654,
    x2: 218.297,
    y2: 1312.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDBDBD",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBDBD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chart_svg__paint4_linear_547_5742",
    x1: 306.297,
    y1: 568.654,
    x2: 306.297,
    y2: 1044.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDBDBD",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBDBD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chart_svg__paint5_linear_547_5742",
    x1: 693.297,
    y1: 783.654,
    x2: 693.297,
    y2: 1259.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDBDBD",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBDBD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chart_svg__paint6_linear_547_5742",
    x1: 271.797,
    y1: 17.056,
    x2: 271.797,
    y2: 493.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADB6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8CAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chart_svg__paint7_linear_547_5742",
    x1: 300.797,
    y1: 17.056,
    x2: 300.797,
    y2: 491.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCAFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chart_svg__paint8_linear_547_5742",
    x1: 183.797,
    y1: 285.056,
    x2: 183.797,
    y2: 759.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEFB6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chart_svg__paint9_linear_547_5742",
    x1: 212.797,
    y1: 285.056,
    x2: 212.797,
    y2: 757.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE297"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chart_svg__paint10_linear_547_5742",
    x1: 15.297,
    y1: 439.036,
    x2: 15.297,
    y2: 686.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADB6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8CAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chart_svg__paint11_linear_547_5742",
    x1: 44.797,
    y1: 439.036,
    x2: 44.797,
    y2: 685.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCAFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chart_svg__paint12_linear_547_5742",
    x1: 659.017,
    y1: 232.056,
    x2: 659.017,
    y2: 705.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#497CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFD1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chart_svg__paint13_linear_547_5742",
    x1: 688.009,
    y1: 232.056,
    x2: 688.009,
    y2: 706.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#326BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6D6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chart_svg__paint14_linear_547_5742",
    x1: 395.297,
    y1: 346.036,
    x2: 395.297,
    y2: 592.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEFB6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chart_svg__paint15_linear_547_5742",
    x1: 424.797,
    y1: 346.036,
    x2: 424.797,
    y2: 591.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE297"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chart_svg__paint16_linear_547_5742",
    x1: 311.525,
    y1: 618.036,
    x2: 311.525,
    y2: 864.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#497CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFD1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chart_svg__paint17_linear_547_5742",
    x1: 341.009,
    y1: 618.036,
    x2: 341.009,
    y2: 864.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#326BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6D6FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "chart_svg__mask-01"
  }, /*#__PURE__*/React.createElement("path", {
    className: "chart_svg__mask-polygon",
    d: "M286.77 0l-29.59 17.01v535.48l29.02 16.91 29.03-17.01V17.01L286.77 0z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "chart_svg__mask-02"
  }, /*#__PURE__*/React.createElement("path", {
    className: "chart_svg__mask-polygon",
    d: "M198.71 268.19l-29.59 17.01v535.48l29.02 16.92 29.02-17.02V285.2l-28.45-17.01z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "chart_svg__mask-03"
  }, /*#__PURE__*/React.createElement("path", {
    className: "chart_svg__mask-polygon",
    d: "M59.04 439.31L30.02 422.3 0 439.31V709.5l30.02 17.02 29.02-16.99V439.31z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "chart_svg__mask-04"
  }, /*#__PURE__*/React.createElement("path", {
    className: "chart_svg__mask-polygon",
    d: "M674.05 215.15l-29.59 17.02v535.47l29.02 16.92 29.02-17.01V232.17l-28.45-17.02z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "chart_svg__mask-05"
  }, /*#__PURE__*/React.createElement("path", {
    className: "chart_svg__mask-polygon",
    d: "M410.29 329.23l-30.02 17.02v270.19l30.02 17.01 29.02-16.99V346.25l-29.02-17.02z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "chart_svg__mask-06"
  }, /*#__PURE__*/React.createElement("path", {
    className: "chart_svg__mask-polygon",
    d: "M326.23 601.43l-30.02 17.01v270.19l30.02 17.01 29.02-16.99V618.44l-29.02-17.01z"
  })))));
}

export default SvgChart;